<div class="ai-doc-wizard">
  <div class="wizard-progress" *ngIf="step > 0">
    <div class="wizard-progress-track">
      <div class="wz-step" [class.wz-step--done]="step >= 1" [class.wz-step--active]="step === 1">
        <div class="wz-step-circle"><i class="ri-file-list-3-line"></i></div>
        <span>{{ 'ai-doc-wizard.steps.documents' | translate }}</span>
      </div>
      <div class="wz-connector" [class.wz-connector--done]="step >= 2"></div>
      <div class="wz-step" [class.wz-step--done]="step >= 2" [class.wz-step--active]="step === 2">
        <div class="wz-step-circle"><i class="bx bx-bot"></i></div>
        <span>{{ 'ai-doc-wizard.steps.analysis' | translate }}</span>
      </div>
      <div class="wz-connector" [class.wz-connector--done]="step >= 3"></div>
      <div class="wz-step" [class.wz-step--done]="step >= 3" [class.wz-step--active]="step === 3">
        <div class="wz-step-circle"><i class="ri-check-double-line"></i></div>
        <span>{{ 'ai-doc-wizard.steps.result' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="wizard-step" [class.wizard-step--back]="slideDir === -1" *ngIf="step === 0">
    <div class="wizard-hero">
      <div class="wizard-hero-icon">
        <span class="hero-spark hero-spark--1"></span>
        <span class="hero-spark hero-spark--2"></span>
        <span class="hero-spark hero-spark--3"></span>
        <i class="bx bx-bot"></i>
      </div>
      <h4>{{ 'ai-doc-wizard.title' | translate }}</h4>
      <p class="text-muted">{{ 'ai-doc-wizard.subtitle' | translate }}</p>
    </div>

    <div class="wizard-options">
      <div class="wizard-option wizard-option--ai" (click)="chooseAi()">
        <div class="option-glow"></div>
        <div class="option-badge"><i class="ri-sparkling-2-fill me-1"></i>{{ 'ai-doc-wizard.recommended' | translate }}
        </div>
        <div class="option-icon"><i class="ri-file-search-line"></i></div>
        <h5>{{ 'ai-doc-wizard.choice.ai.title' | translate }}</h5>
        <p>{{ 'ai-doc-wizard.choice.ai.desc' | translate }}</p>
        <ul class="option-feature-list">
          <li><i class="ri-check-line"></i>{{ 'ai-doc-wizard.choice.ai.feature1' | translate }}</li>
          <li><i class="ri-check-line"></i>{{ 'ai-doc-wizard.choice.ai.feature2' | translate }}</li>
          <li><i class="ri-check-line"></i>{{ 'ai-doc-wizard.choice.ai.feature3' | translate }}</li>
        </ul>
        <div class="option-meta">
          <span class="wz-chip wz-chip--blue"><i class="ri-coin-line"></i>~5 créditos</span>
          <span class="wz-chip wz-chip--green"><i class="ri-timer-line"></i>~30s</span>
        </div>
        <div class="option-cta">{{ 'ai-doc-wizard.choice.ai.cta' | translate }} <i class="ri-arrow-right-line ms-1"></i>
        </div>
      </div>

      <div class="wizard-option wizard-option--manual" (click)="chooseTraditional()">
        <div class="option-icon"><i class="ri-pencil-ruler-2-line"></i></div>
        <h5>{{ 'ai-doc-wizard.choice.manual.title' | translate }}</h5>
        <p>{{ 'ai-doc-wizard.choice.manual.desc' | translate }}</p>
        <ul class="option-feature-list option-feature-list--muted">
          <li><i class="ri-edit-2-line"></i>{{ 'ai-doc-wizard.choice.manual.feature1' | translate }}</li>
          <li><i class="ri-time-line"></i>{{ 'ai-doc-wizard.choice.manual.feature2' | translate }}</li>
          <li><i class="ri-coin-line"></i>{{ 'ai-doc-wizard.choice.manual.feature3' | translate }}</li>
        </ul>
        <div class="option-cta">{{ 'ai-doc-wizard.choice.manual.cta' | translate }} <i
            class="ri-arrow-right-line ms-1"></i></div>
      </div>
    </div>
  </div>

  <div class="wizard-step wizard-step--upload" [class.wizard-step--back]="slideDir === -1" *ngIf="step === 1">
    <div class="wizard-upload-header">
      <button type="button" class="btn btn-sm btn-light" (click)="backToChoice()">
        <i class="ri-arrow-left-line me-1"></i>{{ 'ai-doc-wizard.back' | translate }}
      </button>
      <div class="d-flex align-items-center gap-2">
        <span class="wz-doc-counter" [class.wz-doc-counter--full]="selectedCount >= MAX_DOCS">
          <i class="ri-file-add-line"></i>
          {{ selectedCount }}/{{ MAX_DOCS }} {{ 'ai-doc-wizard.upload.docs-selected' | translate }}
        </span>
      </div>
    </div>
    <div class="ai-security-note mb-3">
      <strong>{{ 'ai-feedback.securityNoticeTitle' | translate }}</strong>
      <span>{{ 'ai-feedback.securityNoticeBody' | translate }}</span>
    </div>

    <!-- <p class="text-muted small mb-3">{{ 'ai-doc-wizard.upload.tip' | translate }}</p> -->

    <div class="upload-layout">
      <div class="upload-layout-panel">
        <div class="upload-panel-header">
          <h6 class="upload-title mb-1">{{ 'ai-doc-wizard.upload.chooseTitle' | translate }}</h6>
          <p class="text-muted small mb-0">{{ 'ai-doc-wizard.upload.chooseSubtitle' | translate }}</p>
        </div>

        <div class="doc-catalog">
          <button type="button" class="doc-catalog-item" *ngFor="let doc of docTypes" [class.selected]="doc.selected"
            [class.disabled]="!doc.selected && selectedCount >= MAX_DOCS" (click)="toggleDoc(doc)">
            <span class="doc-catalog-check">
              <i [class]="doc.selected ? 'ri-checkbox-circle-fill' : 'ri-checkbox-blank-circle-line'"></i>
            </span>
            <span class="doc-catalog-icon"><i [class]="doc.icon"></i></span>
            <span class="doc-catalog-content">
              <span class="d-flex align-items-center gap-2 flex-wrap">
                <strong class="doc-catalog-title">{{ doc.label }}</strong>
                <span class="wz-priority-badge wz-priority-badge--{{ priorityColor(doc.priority) }}">
                  {{ priorityLabel(doc.priority) }}
                </span>
              </span>
              <small class="doc-catalog-description">{{ doc.description }}</small>
            </span>
            <span class="doc-catalog-state">
              <i [class]="doc.file ? 'ri-file-check-line' : 'ri-upload-cloud-line'"></i>
              <span *ngIf="doc.file">{{ 'ai-doc-wizard.upload.readyState' | translate }}</span>
              <span *ngIf="!doc.file && doc.selected">{{ 'ai-doc-wizard.upload.pendingUploadState' | translate }}</span>
              <span *ngIf="!doc.file && !doc.selected">{{ 'ai-doc-wizard.upload.notSelectedState' | translate }}</span>
            </span>
          </button>
        </div>
      </div>

      <div class="upload-layout-panel">
        <div class="upload-panel-header">
          <h6 class="upload-title mb-1">{{ 'ai-doc-wizard.upload.queueTitle' | translate }}</h6>
          <p class="text-muted small mb-0">{{ 'ai-doc-wizard.upload.queueSubtitle' | translate }}</p>
        </div>

        <div class="upload-queue-empty" *ngIf="selectedDocs.length === 0">
          <div class="upload-queue-empty-icon"><i class="ri-inbox-archive-line"></i></div>
          <strong>{{ 'ai-doc-wizard.upload.emptyTitle' | translate }}</strong>
          <small class="text-muted">{{ 'ai-doc-wizard.upload.emptySubtitle' | translate }}</small>
        </div>

        <div class="upload-queue" *ngIf="selectedDocs.length > 0">
          <div class="upload-queue-item" *ngFor="let doc of selectedDocs">
            <div class="upload-queue-item-main">
              <strong>{{ doc.label }}</strong>
              <small class="text-muted" *ngIf="doc.file">{{ doc.file.name }}</small>
              <small class="text-muted" *ngIf="!doc.file">{{ 'ai-doc-wizard.upload.pendingUploadState' | translate
                }}</small>
            </div>
            <div class="upload-queue-actions">
              <label class="btn btn-sm btn-light mb-0" [for]="'file-' + doc.code">
                <i [class]="doc.file ? 'ri-refresh-line me-1' : 'ri-upload-2-line me-1'"></i>
                {{ (doc.file ? 'ai-doc-wizard.upload.replace' : 'ai-doc-wizard.upload.attach') | translate }}
              </label>
              <button type="button" class="btn btn-sm btn-outline-secondary" *ngIf="doc.file"
                (click)="clearDocFile(doc)">
                <i class="ri-close-line me-1"></i>{{ 'ai-doc-wizard.upload.remove' | translate }}
              </button>
            </div>
            <input type="file" [id]="'file-' + doc.code" accept=".pdf,.jpg,.jpeg,.png,.tif,.tiff" hidden
              (change)="onFileChange($event, doc)">
          </div>
        </div>
      </div>
    </div>

    <div class="upload-readiness mt-3" *ngIf="selectedDocs.length > 0">
      <i class="ri-information-line me-1"></i>
      {{ selectedWithFileCount }}/{{ selectedCount }} {{ 'ai-doc-wizard.upload.readyCount' | translate }}
    </div>

    <div class="wizard-footer mt-3">
      <button type="button" class="btn btn-primary w-100 wizard-extract-btn" [disabled]="!canExtract"
        (click)="extract()">
        <i class="bx bx-bot me-2 fs-18"></i>
        {{ 'ai-doc-wizard.upload.extract-btn' | translate }}
        <span class="wz-chip wz-chip--white ms-2">{{ docExtractionCost }} cr</span>
      </button>
    </div>
  </div>

  <div class="wizard-step wizard-processing" [class.wizard-step--back]="slideDir === -1" *ngIf="step === 2">
    <div class="processing-stage">
      <div class="processing-doc-mock">
        <div class="doc-mock-header"><i class="ri-file-text-line"></i></div>
        <div class="doc-mock-line"></div>
        <div class="doc-mock-line w-75"></div>
        <div class="doc-mock-line w-90"></div>
        <div class="doc-mock-line w-60"></div>
        <div class="doc-mock-line w-85"></div>
        <div class="doc-mock-line w-50"></div>
        <div class="doc-mock-scanline"></div>
      </div>

      <div class="processing-transfer" aria-hidden="true">
        <span class="pulse"></span>
        <span class="pulse delay-1"></span>
        <span class="pulse delay-2"></span>
      </div>

      <div class="processing-info">
        <h5 class="processing-title">{{ 'ai-doc-wizard.processing.title' | translate }}</h5>
        <p class="text-muted small mb-3">{{ 'ai-doc-wizard.processing.subtitle' | translate }}</p>
        <ul class="processing-phases">
          <li *ngFor="let phase of processingPhasesList; let i = index" [class.is-done]="i < processingPhase"
            [class.is-active]="i === processingPhase">
            <span class="phase-marker">
              <i *ngIf="i < processingPhase" class="ri-check-line"></i>
              <span *ngIf="i === processingPhase" class="phase-spinner"></span>
              <span *ngIf="i > processingPhase" class="phase-pending"></span>
            </span>
            <span class="phase-label">{{ phase | translate }}</span>
          </li>
        </ul>
        <div class="processing-docs mt-3">
          <div class="processing-doc" *ngFor="let doc of selectedDocs">
            <i [class]="doc.icon"></i>{{ doc.label }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="wizard-step wizard-results" [class.wizard-step--back]="slideDir === -1" *ngIf="step === 3">
    <div class="results-header">
      <div class="results-title">
        <div class="results-success-icon"><i class="ri-check-double-line"></i></div>
        <div>
          <h5 class="mb-0">{{ 'ai-doc-wizard.results.title' | translate }}</h5>
          <small class="text-muted">
            <i class="ri-file-text-line me-1"></i>{{ documentsProcessed.join(', ') }}
          </small>
        </div>
      </div>
      <div class="results-meta">
        <div class="wz-chip wz-chip--red"><i class="ri-coin-line"></i>{{ creditsConsumed }} cr</div>
        <div class="wz-confidence" [class.wz-confidence--high]="confidence >= 0.9"
          [class.wz-confidence--mid]="confidence >= 0.75 && confidence < 0.9"
          [class.wz-confidence--low]="confidence < 0.75">
          <i class="ri-bar-chart-line"></i>{{ (confidence * 100).toFixed(0) }}%
        </div>
      </div>
    </div>

    <p class="results-hint text-muted small mb-2">
      <i class="ri-information-line me-1"></i>
      {{ 'ai-doc-wizard.results.selectionHint' | translate }}
    </p>

    <div class="results-toolbar">
      <div class="results-toolbar-summary">
        <span class="wz-chip wz-chip--green">
          <i class="ri-checkbox-circle-line"></i>{{ acceptedCount }} {{ 'ai-doc-wizard.results.acceptedFields' |
          translate }}
        </span>
        <span class="wz-chip wz-chip--red">
          <i class="ri-close-circle-line"></i>{{ ignoredCount }} {{ 'ai-doc-wizard.results.ignoredFields' | translate }}
        </span>
      </div>
      <div class="results-toolbar-actions">
        <button type="button" class="btn btn-sm btn-light" (click)="acceptAllFields()">
          <i class="ri-check-double-line me-1"></i>{{ 'ai-doc-wizard.results.acceptAll' | translate }}
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="rejectAllFields()">
          <i class="ri-close-circle-line me-1"></i>{{ 'ai-doc-wizard.results.rejectAll' | translate }}
        </button>
      </div>
    </div>

    <div class="results-fields">
      <ng-container *ngFor="let f of resultFields">
        <div class="result-field" *ngIf="getFieldValue(f.key) !== null && getFieldValue(f.key) !== undefined"
          [class.revealed]="isRevealed(f.key)" [class.rejected]="!isFieldAccepted(f.key)"
          [ngStyle]="{ '--field-color': 'var(--bs-' + f.color + ')' }">
          <div class="result-field-icon"><i [class]="f.icon"></i></div>
          <div class="result-field-content">
            <div class="result-field-label">{{ f.label | translate }}</div>
            <div class="result-field-value">{{ getFieldValue(f.key) }}</div>
            <small class="result-field-state" [class.result-field-state--rejected]="!isFieldAccepted(f.key)">
              <i [class]="isFieldAccepted(f.key) ? 'ri-check-line' : 'ri-close-line'"></i>
              {{ (isFieldAccepted(f.key) ? 'ai-doc-wizard.results.fieldSelected' : 'ai-doc-wizard.results.fieldIgnored')
              | translate }}
            </small>
          </div>
          <div class="result-field-actions" *ngIf="isRevealed(f.key)">
            <button type="button" class="field-action field-action--accept" [class.active]="isFieldAccepted(f.key)"
              (click)="acceptField(f.key)">
              <i class="ri-check-line"></i>
            </button>
            <button type="button" class="field-action field-action--reject" [class.active]="!isFieldAccepted(f.key)"
              (click)="rejectField(f.key)">
              <i class="ri-close-line"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="wizard-footer mt-4 d-flex gap-2 align-items-center">
      <button type="button" class="btn btn-light flex-shrink-0" (click)="setStep(1)">
        <i class="ri-refresh-line me-1"></i>{{ 'ai-doc-wizard.results.redo' | translate }}
      </button>
      <small class="text-muted flex-grow-1 text-end me-2">
        {{ acceptedCount }} / {{ totalExtractedCount }} {{ 'ai-doc-wizard.results.acceptedTotal' | translate }}
      </small>
      <button type="button" class="btn btn-success flex-shrink-0" (click)="confirm()" [disabled]="acceptedCount === 0">
        <i class="ri-check-line me-1"></i>{{ 'ai-doc-wizard.results.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
